import { createReducer, on } from "@ngrx/store";
import { EdicaoOutputDto } from "src/app/domain/DTOs/output/jornal/edicao-output.dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterEdicaoPorId, obterEdicaoPorIdSuccess, obterEdicaoPorIdFailure, obterEdicaoPorIdFinish } from "../../actions/Jornal/obter-edicao-por-id.action";

export interface ObterEdicaoPorIdState {
    response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterEdicaoPorIdState = {
    response: null,
    error: null,
};

export const ObterEdicaoPorIdReducer = createReducer(
    initialState,
    on(obterEdicaoPorId, state => ({ ...state, error: null })),
    on(obterEdicaoPorIdSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterEdicaoPorIdFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterEdicaoPorIdFinish, state => ({ ...state, response: null, error: null }))
);
